import {FailCallback, sendRequest} from "../../util/http/HTTP";
import {Dashboard} from "../../util/http/API";
import moment from "moment";
import {
    AppointmentReminderSource,
    ChartsData, ChartsDataSortKey,
    generateTimelinesFrom,
    MenuSource,
} from "./dataForDashboard";
import {DateRange} from "../../components/datePicker/dateRangePicker";
import {TimeFormat} from "../../util/enum";

export enum DateUnit {
    day = "day",
    week = "week",
    month = "month",
    year = "year",
}

export const getDashboardMenuData = (dateRange: DateRange, success: (data?: MenuSource) => void, fail?: FailCallback) => {
    const {from, to} = dateRange
    const param = {
        fromDate: `${moment(from).format(TimeFormat.YYYYMMDD)}T00:00:00.000Z`,
        toDate: `${moment(to).add(1, "day")
            .format(TimeFormat.YYYYMMDD)}T00:00:00.000Z`,
    }
    sendRequest(Dashboard.getDashboardMenuData, param, (response) => {
        success && success(response.data)
    }, fail)
}

export const getAppointmentReminderDashboardData = (dateRange: DateRange, success: (data: Array<ChartsData>) => void, fail?: FailCallback) => {
    const {from, to} = dateRange
    const param = {
        fromDate: `${moment(from).format(TimeFormat.YYYYMMDD)}T00:00:00.000Z`,
        toDate: `${moment(to).add(1, "day")
            .format(TimeFormat.YYYYMMDD)}T00:00:00.000Z`,
        dateType: DateUnit.day,
    }
    sendRequest(Dashboard.getAppointmentReminderDashboardData, param, (response) => {
        if (response.data) {
            const source = response.data as AppointmentReminderSource
            const timeArr = source.statistic.length ? generateTimelinesFrom(dateRange) : []
            if (timeArr.length) {
                let openDt: Array<number> = [], confirmDt: Array<number> = [], timelines: Array<string> = []
                timeArr.forEach((time) => {
                    const dt = source.statistic.find(({year, month, day}) => parseInt(year) === time.year && parseInt(month) === time.month && parseInt(day) === time.day)
                    openDt.push(dt?.patientOpenCount || 0)
                    confirmDt.push(dt?.patientConfirmCount || 0)
                    timelines.push(time.value)
                })
                const openChartsDt: ChartsData = {
                    sortKey: ChartsDataSortKey.patientOpen,
                    name: "Patient Opens",
                    lineColor: "#219653",
                    xAxisData: timelines,
                    yAxisData: openDt,
                }
                const confirmChartsDt: ChartsData = {
                    sortKey: ChartsDataSortKey.patientConfirm,
                    name: "Patient Confirms",
                    lineColor: "#2F80ED",
                    xAxisData: timelines,
                    yAxisData: confirmDt,
                }
                success && success([openChartsDt, confirmChartsDt])
            } else {
                success && success([])
            }
        } else {
            success && success([])
        }
    }, fail)
}

export const getAppointmentNoShowCount = (dateRange: DateRange, success: (data: Array<ChartsData>) => void, fail?: FailCallback) => {
    const {from, to} = dateRange
    const param = {
        fromDate: `${moment(from).format(TimeFormat.YYYYMMDD)}T00:00:00.000Z`,
        toDate: `${moment(to).add(1, "day")
            .format(TimeFormat.YYYYMMDD)}T00:00:00.000Z`,
        dateType: DateUnit.day,
    }
    sendRequest(Dashboard.getAppointmentNoShowCount, param, (response) => {
        if (response.data) {
            const source = response.data as AppointmentReminderSource
            const timeArr = source.statistic.length ? generateTimelinesFrom(dateRange) : []
            if (timeArr.length) {
                const noShowsDt = timeArr.map((time) => {
                    const dt = source.statistic.find(({year, month, day}) => parseInt(year) === time.year && parseInt(month) === time.month && parseInt(day) === time.day)
                    return dt?.noShowCount || 0
                })
                const noShowsChartsDt: ChartsData = {
                    sortKey: ChartsDataSortKey.noShow,
                    name: "No-shows",
                    lineColor: "#EB5757",
                    xAxisData: timeArr.map((time) => time.value),
                    yAxisData: noShowsDt,
                }
                success && success([noShowsChartsDt])
            } else {
                success && success([])
            }
        } else {
            success && success([])
        }
    }, fail)
}

export const getAppointmentReminderCount = (dateRange: DateRange, success: (data: Array<ChartsData>) => void, fail?: FailCallback) => {
    const {from, to} = dateRange
    const param = {
        fromDate: `${moment(from).format(TimeFormat.YYYYMMDD)}T00:00:00.000Z`,
        toDate: `${moment(to).add(1, "day")
            .format(TimeFormat.YYYYMMDD)}T00:00:00.000Z`,
        dateType: DateUnit.day,
    }
    sendRequest(Dashboard.getAppointmentReminderCount, param, (response) => {
        if (response.data) {
            const source = response.data as AppointmentReminderSource
            const timeArr = source.statistic.length ? generateTimelinesFrom(dateRange) : []
            if (timeArr.length) {
                const reminderDt = timeArr.map((time) => {
                    const dt = source.statistic.find(({year, month, day}) => parseInt(year) === time.year && parseInt(month) === time.month && parseInt(day) === time.day)
                    return dt?.appointmentReminderCount || 0
                })
                const reminderChartsDt: ChartsData = {
                    sortKey: ChartsDataSortKey.appointmentReminder,
                    name: "Appointment Reminders (Primary)",
                    lineColor: "#BDBDBD",
                    xAxisData: timeArr.map((time) => time.value),
                    yAxisData: reminderDt,
                }
                success && success([reminderChartsDt])
            } else {
                success && success([])
            }
        } else {
            success && success([])
        }
    }, fail)
}
